import { select, put, take, fork, call } from "redux-saga/effects";
import { LOGOUT_SUCCESS, LOAD_AUTH_USER_SUCCESS } from "../auth/actionTypes";
import { updateSelectedSites } from "../_BETA/selections";
import { groupByProject } from "../_BETA/utils";
import { LOAD_USER_SITES_COMPLETE } from "./actionTypes";
import { updateUserSites } from "./actionCreators";

function* setUserSites(projects, sites) {
  const firstSite = sites[Object.keys(sites)[0]];

  // Cleanse selectedSites of invalid selections
  // I.e., if a selected site is from a project that the user no
  // longer has access to, remove it.
  const { selectedSites = [] } = yield select((state) => state.betaSelections);
  const validSelectedSites =
    selectedSites.length > 0
      ? selectedSites.filter((syncoId) => sites[syncoId] !== undefined)
      : [];

  // If none of the selected sites are valid,
  // set selected sites to be the first valid site
  if (validSelectedSites.length < 1) {
    yield put(updateSelectedSites([firstSite.syncoId]));
  } else {
    // Otherwise, update selected sites to be all valid sites
    yield put(updateSelectedSites(validSelectedSites));
  }

  const projectGroups = groupByProject(projects, sites);

  yield put(updateUserSites({ projects, sites, projectGroups }));
  yield put({ type: LOAD_USER_SITES_COMPLETE });
}

export function* loadUserSitesFlow() {
  while (true) {
    try {
      const { result } = yield take(LOAD_AUTH_USER_SUCCESS);
      // If request was successful, update projects, sites, and projectGroups in store
      const { projects, sites } = result.portfolio;
      yield call(setUserSites, projects, sites);
    } catch (err) {
      console.error(`Something went wrong setting user projects: ${err}`);
    }
  }
}

export function* userSitesFlow() {
  while (true) {
    const loadUserSitesTask = yield fork(loadUserSitesFlow);

    yield take(LOAD_USER_SITES_COMPLETE);

    yield take(LOGOUT_SUCCESS);

    yield loadUserSitesTask.cancel();
  }
}
